<template>
  <div class="submit-thseis-block">
    <div class="card-block">
      <el-alert
        v-if="!isLogin"
        :closable="false"
        show-icon
        title="友情提示 Important Notice"
        type="warning"
      >
        <div class="flex">
          <span
            >为更好地为您提供服务，请首先进行注册/登录，本系统仅登录用户方可提交信息，建议您先注册/登录再进行信息提交。</span
          >
          <span @click="toLogin" class="tel">立即登录 Login</span>
        </div>
      </el-alert>

      <div class="title">
        <img src="@/assets/imgs/icon3.png" />
        <span>考研辅导需求</span>
        <div>为保证您的申请顺利完成，请务必填写详细需求</div>
      </div>

      <el-form
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        label-position="top"
        ref="ruleForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input placeholder="姓名" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="电话 Mobile" prop="mobile">
          <el-input placeholder="务必正确" v-model="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="邮箱 Email" prop="email">
          <el-input
            placeholder="务必正确，后续将据此与您联系"
            v-model="ruleForm.email"
          ></el-input>
          <p>*后续重要通知将发送至上述邮箱，建议您不做修改</p>
        </el-form-item>
        <el-form-item label="本科院校" prop="undergraduate_course_college">
          <el-input
            placeholder="本科院校"
            v-model="ruleForm.undergraduate_course_college"
          ></el-input>
        </el-form-item>
        <el-form-item label="本科专业" prop="undergraduate_program">
          <el-input
            placeholder="本科专业"
            v-model="ruleForm.undergraduate_program"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否二战" prop="is_second">
          <el-select placeholder="请选择" v-model="ruleForm.is_second">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
          <!-- <p></p> -->
        </el-form-item>
        <el-form-item label="目标院校" prop="target_school">
          <el-input
            placeholder="目标院校"
            v-model="ruleForm.target_school"
          ></el-input>
        </el-form-item>
        <el-form-item label="目标学院" prop="target_college">
          <el-input placeholder="目标学院" v-model="ruleForm.target_college"></el-input>
        </el-form-item>
        <el-form-item label="目标专业" prop="target_major">
          <el-input
            placeholder="目标专业"
            v-model="ruleForm.target_major"
          ></el-input>
        </el-form-item>
        <el-form-item label="专业课" prop="professional_courses">
          <el-input
            placeholder="专业课"
            v-model="ruleForm.professional_courses"
          ></el-input>
        </el-form-item>
        <el-form-item label="目标导师" prop="target_teacher">
          <el-input
            placeholder="目标导师"
            v-model="ruleForm.target_teacher"
          ></el-input>
        </el-form-item>

        <el-form-item label="服务项目" prop="services_available">
          <el-select
            multiple
            placeholder="可根据需要选择一项或多项，可不选择。"
            v-model="ruleForm.services_available"
          >
            <el-option
              v-for="(item, index) in serviceItems"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <p>Choose from list below</p> -->
        </el-form-item>
        <el-form-item label="备注 Remarks">
          <el-input
            placeholder="请在此输入您的特殊需求，中英文均可。"
            type="textarea"
            v-model="ruleForm.remarks"
          ></el-input>
          <p>您想备注的信息可放在此处。</p>
        </el-form-item>

        <!-- <el-form-item
            label="Transcript (most recent completed term) – Current students only"
            prop="upload"
          >
            <p>
              请保留参考文献和图表供编辑参考（参考文献不计字数），可依次上传多个文件，单个文件大小不超过{{$store.state.user.maxFileName}}。
            </p>
            <el-upload
              :action="`${$store.state.user.urlLink}api/ajax_file`"
              :before-upload="beforeAvatarUpload"
              :file-list="fileList"
              :on-error="handleError"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              class="upload-demo"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item> -->

        <el-form-item prop="is_agree_pro">
          <span class="color-red">*</span>
          <el-checkbox v-model="ruleForm.is_agree_pro"
            >勾选确认服务协议</el-checkbox
          >
          <span @click="textInfoDialogVisible = true" class="agreement"
            >《科研圈内人服务协议》</span
          >
        </el-form-item>
      </el-form>

      <el-alert
        :closable="false"
        show-icon
        title="重要提示 Important Notice"
        type="warning"
      >
        <div class="flex">
          <span>
            您点击提交后，您的辅导需求将与我们专家库中注册的老师进行匹配，当我们完成匹配后，将会通过邮件与您联系，与您约定在线试听时间和方式。这个过程一般需要3-5天，请耐心等待并请确保邮件和电话正确。
          </span>
        </div>
      </el-alert>

      <div class="align-center">
        <el-button
          :loading="submitLoading"
          @click="submitForm('ruleForm')"
          type="primary"
          >信息确认无误，立即提交 SUBMIT</el-button
        >
      </div>
    </div>

    <!--隐私条款、服务条款-->
    <TextInfo
      :dialogVisible.sync="textInfoDialogVisible"
      :type="textInfoType"
    />
  </div>
</template>

<script>
/**
 * @description 考研辅导需求提交
 */
import * as api from '@/api/postgraduate_guidance'
import * as commonFunc from '@/utils/common-func'
// 隐私条款、服务条款 展示隐藏
import TextInfo from '@/components/TextInfo'

export default {
  name: 'PostgraduateGuidance',
  components: {
    TextInfo,
  },
  data() {
    // // 校验文件上传
    // const uploadFile = (rule, value, callback) => {
    //   if (this.fileList.length === 0) {
    //     callback(new Error('请上传文件'))
    //   } else {
    //     callback()
    //   }
    // }

    //验证手机号是否合法
    const validateTel = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('手机号不能为空'))
      } else {
        const telReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
        if (telReg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确手机号'))
        }
      }
    }

    //验证邮箱是否合法
    const validateEmail = (rule, value, callback) => {
      // const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      const emailTrue = commonFunc.getCharCount(value, '@') == 1
      if (value == '') {
        return callback(new Error('邮箱不能为空'))
        // callback();
        // } else if (mailReg.test(value)) {
      } else if (emailTrue) {
        callback()
      } else {
        callback(new Error('请输入正确的邮箱格式'))
      }
    }

    // 校验勾选确认服务协议
    const confirmAgreement = (rule, value, callback) => {
      if (!this.ruleForm.is_agree_pro) {
        callback(new Error('请勾选确认服务协议《科研圈内人服务协议》'))
      } else {
        callback()
      }
    }

    return {
      textInfoDialogVisible: false, // 隐私条款、服务条款 展示隐藏
      textInfoType: 'service', // 隐私条款（privacy）、服务条款（service） 展示隐藏

      // 服务项目
      serviceItems: [
        {
          label: '专业课全面辅导（30小时）',
          value: '1',
        },
        {
          label: '专业课重点辅导（10小时）',
          value: '2',
        },
        {
          label: '专业课突击辅导（4小时）',
          value: '3',
        },
        {
          label: '笔试+面试辅导（2小时）',
          value: '4',
        },
        {
          label: '个性化指导选择导师（2小时）',
          value: '5',
        },
        {
          label: '个性化指导选择/调剂院校（2小时）',
          value: '6',
        },
      ],
      total: 0, // 订单总量
      submitLoading: false, // 提交按钮loading
      // 提交订单的参数
      ruleForm: {
        name: '', // 姓名
        mobile: '', // 电话
        email: '', // 邮箱
        undergraduate_course_college: '', // 本科院校
        undergraduate_program: '', // 本科专业
        is_second: '', // 是否二战  1二战， 0不是
        target_school: '', // 目标院校
        target_college: '', // 目标学院
        target_major: '', // 目标专业
        professional_courses: '', // 专业课
        target_teacher: '', // 目标导师
        services_available: '', // 服务项目1,1,3
        remarks: '', // 备注
        is_agree_pro: false, // 是否统一用户协议
      },
      // // 上传文件的列表
      // fileList: [],
      rules: {
        name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        mobile: [
          {
            required: true,
            validator: validateTel,
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur',
          },
        ],
        undergraduate_course_college: [
          {
            required: true,
            message: '请输入本科院校',
            trigger: 'blur',
          },
        ],
        undergraduate_program: [
          {
            required: true,
            message: '请输入本科专业',
            trigger: 'blur',
          },
        ],
        target_school: [
          {
            required: true,
            message: '请输入目标院校',
            trigger: 'blur',
          },
        ],
        target_college: [
          {
            required: true,
            message: '请输入目标院校',
            trigger: 'blur',
          },
        ],
        target_major: [
          {
            required: true,
            message: '请输入目标专业',
            trigger: 'blur',
          },
        ],
        professional_courses: [
          {
            required: true,
            message: '请输入专业课',
            trigger: 'blur',
          },
        ],
        target_teacher: [
          {
            required: true,
            message: '请输入目标导师',
            trigger: 'blur',
          },
        ],
        services_available: [
          {
            required: true,
            message: '请选择服务项目',
            trigger: 'change',
          },
        ],
        is_agree_pro: [
          {
            required: true,
            validator: confirmAgreement,
            trigger: 'blur',
          },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
      },
      isLogin: true, // 是否已经登陆
    }
  },
  // 计算属性
  computed: {
    userInfoWatch() {
      return this.$store.state.user.userName
    },
  },
  // 监听
  watch: {
    userInfoWatch(curVal, oldVal) {
      //这里的curVal就是需要监听的值
      this.ruleForm.name = this.$store.state.user.userInfo
        ? this.$store.state.user.userInfo.username
        : ''
      this.ruleForm.email = this.$store.state.user.userInfo
        ? this.$store.state.user.userInfo.email
        : ''
    },

    ruleForm: {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        localStorage.setItem(
          'postgraduate_guidance_form',
          JSON.stringify(this.ruleForm)
        )
      },
      deep: true,
    },
  },
  mounted() {},
  created() {
    this.getOrderTotal() //获取订单总数
    if (
      !localStorage.getItem('userInfo') ||
      localStorage.getItem('userInfo') == 'null'
    ) {
      this.isLogin = false
      this.toLogin()
    }

    // 页面初始化载入用户信息
    this.ruleForm.name = this.$store.state.user.userInfo
      ? this.$store.state.user.userInfo.username
      : ''
    this.ruleForm.email = this.$store.state.user.userInfo
      ? this.$store.state.user.userInfo.email
      : ''

    // 在表单没有提交成功的时候，默认添加到本地缓存中，防止刷新丢失
    this.ruleForm = localStorage.getItem('postgraduate_guidance_form')
      ? JSON.parse(localStorage.getItem('postgraduate_guidance_form'))
      : this.ruleForm
  },
  methods: {
    /**
     * @description 获取订单总数
     */
    getOrderTotal() {
      const _this = this
      const _param = {}
      api
        .orderTotal(_param)
        .then((res) => {
          const _data = res.data

          _this.total = _data.order_total || 0
        })
        .catch((err) => {
          console.log(err)
          // _this.$message.error('操作失败，请稍后刷新页面再试！')
        })
    },

    /**
     * @description 注册提交
     */
    submitForm(formName) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.submitLoading = true
          const _param = JSON.parse(JSON.stringify(this.ruleForm))
          // _this.fileList.map((item) => {
          //   _param.paper_doc_url =
          //     _param.paper_doc_url + ',' + item.response.data
          // })
          // _param.paper_doc_url = _param.paper_doc_url.substring(1)
          _param.is_agree_pro = this.ruleForm.is_agree_pro ? '1' : '0'
          _param.services_available = _param.services_available.toString() // 多选转逗号隔开的字符串
          api
            .submitOrder(_param)
            .then((res) => {
              _this.submitLoading = false
              // 清理本地缓存的论文润色的表单信息
              localStorage.removeItem('postgraduate_guidance_form')

              _this.$message.success('提交成功！')
              _this.$router.push({
                path: '/order?activeName=postgraduate_guidance',
              })
            })
            .catch((err) => {
              _this.submitLoading = false
              console.log(err)
              if (err == 'Error: 请登录') {
                setTimeout(() => {
                  _this.toLogin() // 注册、登陆
                }, 500)
              }
            })
        } else {
          _this.$message.error('请根据系统提示将必填信息填写完整，再进行提交。')
          console.log('error submit!!')
          return false
        }
      })
    },

    // /**
    //  * @description 上传失败的钩子函数
    //  */
    // handleError(err, file, fileList) {
    //   // this.$message.error('上传失败，请再次尝试！')
    //   this.$message.error(err.error_msg)
    // },

    // /**
    //  * @description 上传成功的钩子函数
    //  */
    // handleSuccess(response, file, fileList) {
    //   if (response.error_msg == '请登录') {
    //     this.$message.error('登录之后，才能允许上传文件，请先登录！')
    //     this.fileList = []
    //     setTimeout(() => {
    //       this.toLogin()
    //     }, 1000)
    //   } else if (response.error_code == 1) {
    //     // this.$message.error('上传失败，请重新再试')
    //     this.$message.error(response.error_msg)
    //     this.fileList = []
    //   } else {
    //     this.fileList = fileList.slice(-10) // 最大10个文件
    //   }
    // },

    // /**
    //  * @description 限制上传文件的大小
    //  */
    // beforeAvatarUpload(file) {
    //   // const isJPG = file.type === 'image/jpeg';
    //   const isOverSize = file.size / 1024 / 1024 <= this.$store.state.user.maxFile

    //   // if (!isJPG) {
    //   //   this.$message.error('上传头像图片只能是 JPG 格式!');
    //   // }
    //   if (!isOverSize) {
    //     this.$message.error(`上传的文件大小不能超过${this.$store.state.user.maxFileName}!`)
    //   }
    //   return isOverSize
    // },

    // /**
    //  * @description 删除文件
    //  */
    // handleRemove(file, fileList) {
    //   this.fileList = fileList
    // },

    // /**
    //  * @description 点击去注册
    //  */
    // toRegister() {
    //   this.$store.dispatch('user/toRegister', { toggle: true })
    // },

    /**
     * @description 点击去登录
     */
    toLogin() {
      this.$store.dispatch('user/toLogin', { toggle: true })
    },

  },
}
</script>
<style lang="scss" scoped>
.submit-thseis-block {
  .card-block {
    // width: 100%;
    padding: 20px;
    margin: 0 0 40px 0;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    -moz-box-shadow: 15px 15px 0 #dddddd; /* 老的 Firefox */
    box-shadow: 15px 15px 0 #dddddd;

    .title {
      display: flex;
      align-items: center;
      font-size: 24px;
      padding: 0 20px 20px 20px;
      border-bottom: 1px solid #dcdfe6;

      img {
        display: block;
        width: 30px;
        margin: 0 10px 0 0;
      }

      & > div {
        font-size: 14px;
        color: #98a5a6;
        margin: 0 0 0 10px;
      }
    }

    /deep/.el-form {
      // margin: 50px 200px;

      .el-form-item {
        padding: 0 200px;
        margin: 30px 0;
      }

      // .el-button {
      //   margin: 100px 0 0 0;
      //   width: 550px;
      // }

      .el-form-item__label {
        padding-bottom: 0;
      }

      .el-select {
        width: 100%;
      }

      p {
        margin: 0;
        line-height: 1.5;
      }

      a {
        color: $colorNormal;
      }

      .agreement {
        color: $colorNormal;
        cursor: pointer;
      }

      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #606266;
      }

      .color-red {
        color: #f46c6c;
        margin-right: 4px;
      }
    }

    .align-center {
      text-align: center;

      .el-button {
        width: 500px;
        height: 70px;
        font-size: 22px;
      }
    }

    .requirement {
      margin: 0 0 30px 0;

      h3 {
        font-size: 16px;
        padding: 0 20px;
      }

      /deep/.el-collapse {
        padding: 0 20px;
        border-top: 1px solid #dcdfe6;
        border-bottom: 1px solid #dcdfe6;

        .el-collapse-item__header {
          font-size: 16px;
        }

        .el-collapse-item__content {
          > div {
            font-size: 14px;
          }
        }
      }
    }
  }

  /deep/.el-alert {
    margin: 0 0 15px 0;
    .el-alert__content {
      width: 100%;
    }

    .el-alert__title {
      font-size: 16px;
    }

    .flex {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .tel {
      cursor: pointer;
      display: inline-block;
      width: 180px;
      height: 36px;
      line-height: 36px;
      border-radius: 3px;
      text-align: center;
      color: #ffffff;
      background: #ea870f;
      margin-top: -20px;
    }
  }
}
</style>